import { createRoutesFromElements, Route } from 'react-router-dom'

import { LoggedOut, LoggingOut } from 'authentication/Logout'
import NotFoundPage from 'infrastructure/NotFoundPage'
import { PrivateRoutes } from 'infrastructure/shared/components'
import LoadSitemodel from './Load'
import EditSitemodel from './Edit'

const SiteRoutes = createRoutesFromElements(
  <>
    <Route element={<PrivateRoutes />}>
      {/* No support for optional parameters in v6 */}
      {/* https://reactrouter.com/docs/en/v6/faq#what-happened-to-regexp-routes-paths */}
      <Route index element={<LoadSitemodel isIndex />} />
      <Route path=':sitemodelUuid' element={<LoadSitemodel />} />
      <Route path=':sitemodelUuid/edit' element={<EditSitemodel />} />
      <Route path='masterdata/:objectclassUuid' element={<LoadSitemodel />} />
      <Route path='*' element={<NotFoundPage />} />
    </Route>

    <Route path='/logout' element={<LoggingOut />} />
    <Route path='/logged-out' element={<LoggedOut />} />
  </>
)

export default SiteRoutes
